
import { mixins } from "vue-class-component";
import { Vue, Component, Prop } from "vue-property-decorator";

// Mixins
import S3BucketMixin from "@/mixins/storage/S3BucketMixins";

@Component
export default class CardChipAvatar extends mixins(S3BucketMixin) {
  @Prop(String) readonly avatar!: string;

  async mounted() {
    if (this.avatar) {
      await this.getFile(this.avatar);
    }
  }

  async updated() {
    if (this.avatar) {
      await this.getFile(this.avatar);
    }
  }
}
